import { createV3Queries } from "@query/utils/createV3Queries";
import { payerRowsApi } from "@api";

/**
 * v3 registry for the contractor-seat client search rows
 * (`GET /v3/search/payer-rows`) — the denormalized, materialized row that backs
 * the clients (payers) list. This is the v3 twin of the v1 search-service
 * `/search/payer-row`: cursor pagination + the legacy filter surface (search
 * string, status, engagement/link-request status, autopay, tax-share),
 * returning a `PayerRow` that carries the columns the table renders.
 */
export const queriesPayerRows = createV3Queries("payerRowsApi", payerRowsApi);
